import { useEffect, useState } from "react";
import { HubConnectionState } from "@microsoft/signalr";
import SignalRProvider from "../providers/SignalRProvider";

const INTERVAL_MS = 3000; // 3 seconds

export function useSignalR() {
    const [signalRProviderConnectionState, setSignalRProviderConnectionState] =
        useState(SignalRProvider.GetState());

    useEffect(() => {
        const interval = setInterval(() => {
            const currentStatus = SignalRProvider.GetState();
            setSignalRProviderConnectionState(currentStatus);
        }, INTERVAL_MS);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const isSignalRConnected =
        signalRProviderConnectionState === HubConnectionState.Connected;

    return { signalRProviderConnectionState, isSignalRConnected };
}
